export function makeDecimalNumber(num) {
    return num.toLocaleString(undefined, {
       maximumFractionDigits: 2,
       minimumFractionDigits: 2,
    })
}